
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue"
import FoliosEnrollmentContent from "./Components/FoliosEnrollmentContent.vue";

export default defineComponent({
  name: "FoliosEnrollmentPage",
  components: {
    BreadCrumb,
    FoliosEnrollmentContent,
  },
});
